<template>
  <div>
    <v-btn
      @click.prevent="addDocument"
      class="text-xs-center"
      color="purple darken-4"
      outline
      block
    >
      Conta de Energia
    </v-btn>
    <v-dialog v-model="documentDialog" max-width="992px" lazy>
      <v-card class="pa-3">
        <v-card-title class="py-2">
          <v-layout align-center justify-end row fill-height>
            <div class="headline font-weight-bold mx-auto">
              Conta de Energia
            </div>
          </v-layout>
          <v-icon @click="documentDialog = false" class="ml-auto" color="orange"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <v-layout row wrap>
            <v-flex sm12 md4 v-for="(photo, index) in idDocs" :key="index">
              <v-card class="mb-2 mx-2 pa-1">
                <v-card-title class="title pa-0 my-0">
                  <v-layout row>
                    <v-flex pa-1 class="text-truncate">{{ photo.name }}</v-flex>
                    <v-flex shrink pa-1>
                      <v-icon
                        @click="deleteDocument(photo.name, null)"
                        color="red"
                        >mdi-delete</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-card-title>
                <v-flex
                  v-if="photo.progress < 100"
                  class="subheading mx-0 pb-2"
                >
                  Salvando arquivo...
                  <v-progress-linear
                    height="3"
                    class="my-0"
                    :value="photo.progress"
                    color="purple darken-4"
                  ></v-progress-linear>
                </v-flex>
                <v-img
                  v-if="photo.preview"
                  :src="photo.preview"
                  :contain="true"
                  class="d-flex"
                ></v-img>
                <pdf v-if="photo.pdfPreview" :src="photo.pdfPreview"></pdf>
              </v-card>
            </v-flex>
          </v-layout>
          <p v-if="idDocs?.length == 0" class="py-2 text-md-center">
            Nenhuma Conta de Energia foi adicionada
          </p>
        </v-card-text>
        <v-card-actions>
          <div class="ml-auto">
            <v-btn color="orange" text @click="documentDialog = false"
              >Fechar</v-btn
            >
            <v-btn color="primary" text @click="pickIdDoc()">
              <v-icon class="mr-2">mdi-upload</v-icon>Adicionar</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <input
      type="file"
      ref="idDoc"
      multiple
      style="display: none"
      accept="application/pdf,image/*"
      @change="pickedPhotos($event)"
      :key="docKey"
    />
  </div>
</template>

<script>
import { uploadEnergyBill, removeEnergyBill } from "../../services/sales";
import pdf from "vue-pdf";

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
  },
  components: {
    pdf,
  },
  data() {
    return {
      idDocs: [],
      documentDialog: false,
      color: "",
      snackMessage: "",
      snackbar: false,
      docKey: 0,
    };
  },
  methods: {
    pickIdDoc() {
      this.$refs.idDoc.click();
    },
    async pickedPhotos(event) {
      const docFiles = event?.target?.files;
      if (!docFiles) return;
      for (let doc of docFiles) {
        if (doc.size < 512) {
          this.snack(`O arquivo ${doc.name} é inválido!`, "red");
        } else if (doc.size > 10485760) {
          this.snack(
            `O arquivo ${doc.name} é muito grande! O limite é de 10MB.`,
            "red",
          );
        } else if (this.idDocs.find((item) => item.name === doc.name)) {
          this.snack(`${doc.name} já foi adicionado a lista!`, "red");
        } else {
          doc.progress = 0;
          this.idDocs.push(doc);
          this.$emit("updateDocList", this.idDocs);
          let uploadTask = uploadEnergyBill(this.email, doc);
          if (uploadTask) {
            uploadTask.on(
              "state_changed",
              (s) => {
                const progress = (s.bytesTransferred / s.totalBytes) * 100;
                doc.progress = progress;
                this.docKey++;
              },
              (error) => {
                this.deleteDocument(doc.name, null);
                this.snack(
                  `Erro ao anexar arquivo ${doc.name}, tente novamente!`,
                  "red",
                );
                console.error(error);
              },
              async () => {
                doc.progress = 100;
                doc.downloadURL =
                  await uploadTask.snapshot.ref.getDownloadURL();
                doc.billPath = uploadTask.snapshot.ref.fullPath;
                if (doc.type.includes("image")) {
                  doc.preview = URL.createObjectURL(doc);
                } else {
                  doc.pdfPreview = URL.createObjectURL(doc);
                }
                this.$emit("updateDocList", this.idDocs);
                this.docKey++;
              },
            );
          } else {
            this.snack("Erro ao anexar arquivo, tente novamente!", "red");
          }
        }
      }
      this.docKey++;
      this.documentDialog = true;
    },
    deleteDocument(fileName, email) {
      const index = this.idDocs?.findIndex((item) => item.name == fileName);
      removeEnergyBill(email || this.email, fileName);
      this.idDocs?.splice(index, 1);
      this.$emit("updateDocList", this.idDocs);
    },
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    addDocument() {
      if (!this.email) {
        this.snack(
          "Preencha o email do membro antes de anexar a conta de energia.",
          "red",
        );
        return;
      }
      if (!this.idDocs?.length > 0) {
        this.pickIdDoc();
      } else {
        this.documentDialog = true;
      }
    },
  },
  watch: {
    email(newEmail, oldEmail) {
      const files = this.idDocs.map((doc) => doc.name);
      for (const fileName of files) {
        console.log("deletando", fileName);
        this.deleteDocument(fileName, oldEmail);
      }
    },
  },
};
</script>
